<div *ngIf="!isError">
    <app-promotion-leaderboard-my-rank
            [myInfo]="myInfo"
            [isChase]="isChase"
            [isWsopPrizeCustom]="isWsopPrizeCustom"
            [prizeVisibility]="prizeVisibility"
            [onlyCoin]="onlyCoin"
            [hideSymbol]="hideSymbol"
            [hideCustomSymbol]="hideCustomSymbol"
            [nationalityName]="nationalityName"
            *ngIf="!hideRank"
    >
    </app-promotion-leaderboard-my-rank>

    <div class="group-area">
        <div class="set-dropdown-navigation" (click)="toggleSelectLayer()">
            <div class="ui-inputgroup">
                <span class="ui-inputgroup-addon blind-icon"></span>
                <div class="blind-text">{{ activatedSubSet?.name }}</div>
                <span class="ui-inputgroup-addon blind-icon-down"></span>
            </div>
            <ul class="dropdown-layer" [class.layer-open]="isLayerOpen">
                <li *ngFor="let subset of activatedSet?.subsets" [class.active]="activatedSubSet === subset" (click)="changeActivatedSubSet(subset)">
                    {{ subset.name }}
                </li>
            </ul>
        </div>

        <div class="calender-container" *ngIf="!isPeriodDate">
            <div class="ui-inputgroup">
                <span class="ui-inputgroup-addon calender-icon"></span>
                <p-calendar class="basic-calendar" dateFormat="dd / mm / yy" hourFormat="24"
                            [class.disabledNavigatePrev]="navigateButton.prev" [class.disabledNavigateNext]="navigateButton.next"
                            [(ngModel)]="selectedLeaderboardDate" [minDate]="minDate" [maxDate]="maxDate" [defaultDate]="utc"
                            [disabledDates]="invalidDates"  [inputStyle]="{ fontWeight: 'normal' }"
                            [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"
                            [showIcon]="true" [icon]="'pi pi-angle-down'" [readonlyInput]="true"
                            (onSelect)="setDateNavigate()" (onMonthChange)="checkMonth($event)"
                            (onFocus)="checkMonth()"
                >
                </p-calendar>
            </div>
        </div>

        <div class="set-navigation" *ngIf="isPeriodDate">
            <div><a class="pi pi-angle-left"  [ngClass]="{ 'disabled': !prevSet }" (click)="navigateSet(prevSet.setId)"></a></div>
            <div class="activated-set-title">{{ activatedSet?.name }}</div>
            <div><a class="pi pi-angle-right" [ngClass]="{ 'disabled': !nextSet }" (click)="navigateSet(nextSet.setId)"></a></div>
        </div>

        <div class="set-refresh" (click)="refresh($event)"></div>
    </div>

    <app-promotion-leaderboard-list-table
            [myInfo]="myInfo" [prizePoolList]="prizePoolList"
            [progress]="progress" [isMaintenance]="isMaintenance"
            [type]="type" [isScrolling]="isScrolling"
            [promotionId]="promotionId" [nickname]="nickname"
            [brandId]="brandId" [siteId]="siteId"
            [rankingList]="rankingList" [countryCodes]="countryCodes"
            [playerLimit]="playerLimit" [prizeVisibility]="prizeVisibility"
            [onlyCoin]="onlyCoin" [hideSymbol]="hideSymbol" [hideCustomSymbol]="hideCustomSymbol"
            [countryCode]="countryCode" [focusFirstPlayer]="focusFirstPlayer"
    >
    </app-promotion-leaderboard-list-table>
</div>
